import { Form as AntForm } from 'antd';
import styled from 'styled-components';

export const FormComponent = styled(AntForm)`
  &&& {
    .required-hidden {
      .ant-form-item-label
        > label.ant-form-item-required:not(
          .ant-form-item-required-mark-optional
        )::before {
        content: unset;
      }
    }
    .ant-form-item-required {
      &::before {
        position: absolute;
        top: 0;
        right: -7px;
        margin: unset;
      }
    }

    .ant-checkbox-wrapper {
      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: var(--v3-primary-color);
      }
      &:hover,
      &:focus {
        .ant-checkbox-inner {
          border-color: var(--v3-primary-color);
        }
      }
      input:focus + .ant-checkbox-inner {
        border-color: var(--v3-primary-color);
      }
      .ant-checkbox-checked::after {
        border-color: var(--v3-primary-color);
      }
    }

    .ant-form-item-has-error {
      .ant-checkbox-wrapper {
        .ant-checkbox-inner {
          border-color: var(--v3-error-color);
        }
      }
    }
  }
`;
